import RaporHead from "../../../../../components/categories/siakad/laporan_adab/rapor/HomeHead"
export default function Home() {
  
  return (
    <RaporHead />
  );
}
